import React, { useState, createContext, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { toast } from 'react-toastify';

import { getUploadData } from '../../../services/profile';
import useAuth from '../../hooks/useAuth';
import { emptyProfileObject } from '../../constants/profileSamples';
import { CREATE_PROFILE_FORM_CACHE_KEY, PROFILE_UPLOAD_IMAGE_LIMIT, PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED, PROFILE_UPLOAD_STATUS_NOT_SELECTED, PROFILE_UPLOAD_STATUS_UPLOADED } from '../../constants/Constants';
export const ProfileContext = createContext();
export const UPLOADING_IMG = 'This URL is used to block repeated Image Uploads';
export const UPLOAD_IMG_FAILED = 'URL to indicate failed upload';
export const UPLOAD_DATA_FAILED_MESSAGE = 'We are currently facing issues with uplaoding photos. Please try again later.';

export const updateCache = (key, value, setCache) => {
  setCache((cache) => ({
    ...cache, // Preserve existing cache data
    [key]: value, // Dynamically update the specified key
  }));
}; 

export const ProfileState = ({ children }) => {
	const {getToken} = useAuth();
	// Personal Details
	const [userId, setUserId] = useState('');
	const [cachedData, setCachedData] = useState(emptyProfileObject);
	const [firstName, setFirstName] = useState('');
	const [firstNameError, setFirstNameError] = useState(false);
	const [lastName, setLastName] = useState('');
	const [lastNameError, setLastNameError] = useState(false);
	const [dateOfBirth, setDateOfBirth] = useState('');
	const [dateOfBirthError, setDateOfBirthError] = useState(false);
	const [timeOfBirth, setTimeOfBirth] = useState(null);
	const [gender, setGender] = useState('');
	const [genderError, setGenderError] = useState(false);
	const [city, setCity] = useState('');
	const [cityError, setCityError] = useState(false);
	const [state, setState] = useState('');
	const [stateError, setStateError] = useState(false);
	const [country, setCountry] = useState('');
	const [countryError, setCountryError] = useState(false);
	const [pin, setPin] = useState('');
	const [pinError, setPinError] = useState(false);
	// Career Details
	const [qualification, setQualification] = useState([]);
	const [qualificationError, setQualificationError] = useState(false);
	const [occupation, setOccupation] = useState('');
	const [occupationError, setOccupationError] = useState(false);
	const [employedIn, setEmployedIn] = useState('');
	const [employedInError, setEmployedInError] = useState(false);
	const [annualIncome, setAnnualIncome] = useState('');
	const [annualIncomeError, setAnnualIncomeError] = useState(false);
	const [isNRI, setIsNRI] = useState(false);
	// Social Details
	const [maritalStatus, setMaritalStatus] = useState('');
	const [maritalStatusError, setMaritalStatusError] = useState('');
	const [motherTongue, setMotherTongue] = useState('');
	const [motherTongueError, setMotherTongueError] = useState('');
	const [religion, setReligion] = useState('');
	const [religionError, setReligionError] = useState('');
	const [caste, setCaste] = useState('');
	const [casteError, setCasteError] = useState('');
	const [nakshatra, setNakshatra] = useState('');
	const [nakshatraError, setNakshatraError] = useState('');
	const [kuldevta, setKuldevta] = useState('');
	const [kuldevtaError, setKuldevtaError] = useState('');
	const [gotra, setGotra] = useState('');
	const [gotraError, setGotraError] = useState('');
	const [rashi, setRashi] = useState('');
	const [rashiError, setRashiError] = useState('');
	const [languagesKnown, setLanguagesKnown] = useState([]);
	const [languagesKnownError, setLanguagesKnownError] = useState(false);
	//Other details
	const [bloodGroup, setBloodGroup] = useState('');
	const [bloodGroupError, setBloodGroupError] = useState('');
	const [height, setHeight] = useState('');
	const [heightFeet, setHeightFeet] = useState(3);
	const [heightInch, setHeightInch] = useState(0);
	const [heightError, setHeightError] = useState('');
	const [weight, setWeight] = useState('');
	const [weightError, setWeightError] = useState('');
	const [foodHabits, setFoodHabits] = useState('');
	const [foodHabitsError, setFoodHabitsError] = useState('');
	const [drinkHabits, setDrinkHabits] = useState('');
	const [drinkHabitsError, setDrinkHabitsError] = useState('');
	const [smokeHabits, setSmokeHabits] = useState('');
	const [smokeHabitsError, setSmokeHabitsError] = useState('');
	const [complexion, setComplexion] = useState('');
	const [complexionError, setComplexionError] = useState('');
	//Familydetails
	const [fatherName, setFatherName] = useState('');
	const [fatherNameError, setFatherNameError] = useState('');
	const [fatherNumber, setFatherNumber] = useState('');
	const [fatherNumberCountry, setFatherNumberCountry] = useState(91);
	const [fatherNumberError, setFatherNumberError] = useState('');
	const [motherName, setMotherName] = useState('');
	const [motherNameError, setMotherNameError] = useState('');
	const [motherNumber, setMotherNumber] = useState('');
	const [motherNumberCountry, setMotherNumberCountry] = useState(91);
	const [motherNumberError, setMotherNumberError] = useState('');
	//About details
	const [bio, setBio] = useState('');
	const [bioError, setBioError] = useState('');
	const [userPreferences, setUserPreferences] = useState('');
	const [userPreferencesError, setUserPreferencesError] = useState('');
	const [math, setMath] = useState('');
	const [mathError, setMathError] = useState('');
	const [contactNumber, setContactNumber] = useState('');
	const [contactNumberCountry, setContactNumberCountry] = useState(91);
	const [contactNumberError, setContactNumberError] = useState('');
	const [contactEmail, setContactEmail] = useState('');
	const [contactEmailError, setContactEmailError] = useState('');
	const [profileUploadDataKeys, setProfileUploadDataKeys] = useState([]);
	const [profileImageUploadUrls, setProfileImageUploadUrls] = useState([]);
	const [localProfileImageUrls, setLocalProfileImageUrls] = useState([]);
	const [profileImageUploadStatuses, setProfileImageUploadStatuses] = useState([]);

	const [tncAckCheckedDuringProfile, setTncAckCheckedDuringProfile] = useState(false);
	const [declarationAckCheckedDuringProfile, setDeclarationAckCheckedDuringProfile] = useState(false);

	const [showIntroModal, setShowIntroModal] = useState(true);

	const stateSetters = {
		firstName: setFirstName,
		lastName: setLastName,
		dateOfBirth: setDateOfBirth,
		timeOfBirth: setTimeOfBirth,
		gender: setGender,
		city: setCity,
		state: setState,
		pin: setPin,
		country: setCountry,
		qualification: setQualification,
		occupation: setOccupation,
		employedIn: setEmployedIn,
		annualIncome: setAnnualIncome,
		isNRI: setIsNRI,
		maritalStatus: setMaritalStatus,
		motherTongue: setMotherTongue,
		religion: setReligion,
		caste: setCaste,
		gotra: setGotra,
		nakshatra: setNakshatra,
		kuldevta: setKuldevta,
		rashi: setRashi,
		languagesKnown: setLanguagesKnown,
		bloodGroup: setBloodGroup,
		height: setHeight,
		heightFeet: setHeightFeet,
		heightInch: setHeightInch,
		weight: setWeight,
		foodHabits: setFoodHabits,
		drinkHabits: setDrinkHabits,
		smokeHabits: setSmokeHabits,
		complexion: setComplexion,
		fatherName: setFatherName,
		fatherNumber: setFatherNumber,
		fatherNumberCountry: setFatherNumberCountry,
		motherName: setMotherName,
		motherNumber: setMotherNumber,
		motherNumberCountry: setMotherNumberCountry,
		contactNumber: setContactNumber,
		contactNumberCountry: setContactNumberCountry,
		contactEmail: setContactEmail,
		bio: setBio,
		userPreferences: setUserPreferences,
		math: setMath
	  };

	  const fetchImageUploadData = async () => {
		try {
			if(profileUploadDataKeys?.length > 0) {
				return;
			}
			let token = getToken()?.token;
			let response = await getUploadData(token);
			if (response.errors) {
				throw new Error(response.errors[0]?.message || 'Error fetching upload data');
			}
			const uploadData = response.data.getUploadData;
			
			// Initialize arrays for each upload data
			const urls = uploadData.map(data => data.url);
			const keys = uploadData.map(data => data.key);
			const statuses = new Array(uploadData.length).fill(PROFILE_UPLOAD_STATUS_NOT_SELECTED);
			
			setProfileImageUploadUrls(urls);
			setProfileUploadDataKeys(keys);
			setProfileImageUploadStatuses(statuses);
			setLocalProfileImageUrls(new Array(uploadData.length).fill(""));
			
			return urls;
		} catch(error) {
			setProfileImageUploadStatuses(new Array(PROFILE_UPLOAD_IMAGE_LIMIT).fill(PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED));
			console.error('Debug error in getting upload data', { error });
			toast.error(UPLOAD_DATA_FAILED_MESSAGE);
		}
	  }

	useEffect(() => {
		let token = getToken()?.token;
		if(!token) {
			setProfileImageUploadStatuses(new Array(profileImageUploadStatuses.length).fill(PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED));
			return;
		}

		try {
			let decodedJwt = jwt_decode(token);
			var userId = decodedJwt.sub;
			setUserId(userId);
			const cachedData = localStorage.getItem(`${CREATE_PROFILE_FORM_CACHE_KEY}${userId}`);
			if (cachedData) {
				const parsedData = JSON.parse(cachedData);
				setCachedData(parsedData);
			
				// Dynamically update states using setters
				Object.keys(parsedData).forEach((key) => {
					const value = parsedData[key];
					if (stateSetters[key]) {
						stateSetters[key](value); // Call the setter for the corresponding state
					}
				});
			}
		} catch(err)
		{
			console.error('Error in pull cachced data for profile context',err)
		}
	}, []);

	//Update local storage when the user makes a change
	useEffect(()=>{
		if (Object.keys(cachedData).length > 0 && userId !== "") {
			localStorage.setItem(`${CREATE_PROFILE_FORM_CACHE_KEY}${userId}`, JSON.stringify(cachedData));
		  }
	},[cachedData, userId])

	return (
		<ProfileContext.Provider
			value={{
				// Personal Details
				userId,
				firstName,
				setCachedData,
				setFirstName,
				firstNameError,
				setFirstNameError,
				lastName,
				setLastName,
				lastNameError,
				setLastNameError,
				dateOfBirth,
				setDateOfBirth,
				dateOfBirthError,
				setDateOfBirthError,
				gender,
				setGender,
				genderError,
				setGenderError,
				city,
				setCity,
				cityError,
				setCityError,
				state,
				setState,
				stateError,
				setStateError,
				country,
				setCountry,
				countryError,
				setCountryError,
				pin,
				setPin,
				pinError,
				setPinError,
				// Career Details
				qualification,
				setQualification,
				qualificationError,
				setQualificationError,
				occupation,
				setOccupation,
				occupationError,
				setOccupationError,
				employedIn,
				setEmployedIn,
				employedInError,
				setEmployedInError,
				annualIncome,
				setAnnualIncome,
				annualIncomeError,
				setAnnualIncomeError,
				isNRI,
				setIsNRI,
				// Social Details
				maritalStatus,
				setMaritalStatus,
				motherTongue,
				setMotherTongue,
				religion,
				setReligion,
				caste,
				setCaste,
				nakshatra,
				setNakshatra,
				nakshatraError,
				setNakshatraError,
				kuldevta,
				setKuldevta,
				kuldevtaError,
				setKuldevtaError,
				gotra,
				setGotra,
				gotraError,
				setGotraError,
				rashi,
				setRashi,
				rashiError,
				setRashiError,
				languagesKnown,
				setLanguagesKnown,
				maritalStatusError,
				setMaritalStatusError,
				motherTongueError,
				setMotherTongueError,
				religionError,
				setReligionError,
				casteError,
				setCasteError,
				languagesKnownError,
				setLanguagesKnownError,
				complexion,
				setComplexion,
				complexionError,
				setComplexionError,
				//Other details
				bloodGroup,
				setBloodGroup,
				height,
				setHeight,
				heightFeet,
				setHeightFeet,
				heightInch,
				setHeightInch,
				weight,
				setWeight,
				foodHabits,
				setFoodHabits,
				bloodGroupError,
				setBloodGroupError,
				heightError,
				setHeightError,
				weightError,
				setWeightError,
				foodHabitsError,
				setFoodHabitsError,
				drinkHabits,
				setDrinkHabits,
				drinkHabitsError, 
				setDrinkHabitsError,
				smokeHabits,
				setSmokeHabits,
				smokeHabitsError,
				setSmokeHabitsError,

				//Familydetails
				fatherName,
				setFatherName,
				fatherNumber,
				setFatherNumber,
				motherName,
				setMotherName,
				motherNumber,
				setMotherNumber,
				fatherNameError,
				setFatherNameError,
				fatherNumberCountry,
				setFatherNumberCountry,
				motherNumberCountry,
				setMotherNumberCountry,
				fatherNumberError,
				setFatherNumberError,
				motherNameError,
				setMotherNameError,
				motherNumberError,
				setMotherNumberError,
				//About details
				bio,
				setBio,
				timeOfBirth,
				setTimeOfBirth,
				bioError,
				setBioError,
				userPreferences,
				setUserPreferences,
				userPreferencesError,
				setUserPreferencesError,
				math,
				setMath,
				mathError,
				setMathError,
				contactNumber,
				setContactNumber,
				contactNumberCountry,
				setContactNumberCountry,
				contactNumberError,
				setContactNumberError,
				contactEmail,
				setContactEmail,
				contactEmailError,
				setContactEmailError,

				profileUploadDataKeys,
				setProfileUploadDataKeys,
				profileImageUploadUrls,
				profileImageUploadStatuses,
				setProfileImageUploadStatuses,
				localProfileImageUrls,
				setLocalProfileImageUrls,
				fetchImageUploadData,
				
				tncAckCheckedDuringProfile,
				setTncAckCheckedDuringProfile,
				declarationAckCheckedDuringProfile,
				setDeclarationAckCheckedDuringProfile,
				showIntroModal,
				setShowIntroModal,
			}}
		>
			{children}
		</ProfileContext.Provider>
	);
};
